<template>
  <b-card>
    <table-library />
  </b-card>
</template>

<script>
import TableLibrary from '@/layouts/components/TableLibrary.vue'

import {
  BCard,
} from 'bootstrap-vue'

export default {
  components: {
    BCard,
    TableLibrary,
  },
}
</script>
